import Main from './components/Main/Main';
import WeatherMain from './components/WeatherMain/WeatherMain';
import PlanMain from './components/PlanMain/PlanMain';
import WeatherInfo from './components/WeatherInfo/WeatherInfo';
import TodayWeather from './components/TodayWeather/TodayWeather';
import We from './components/We/We';
import YS from './components/YS/YS';
import { preload } from './api/locationApi';
import './App.css';
import './common.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// 앱 시작 시 ���치 정보 사전 조회
preload();

function App() {
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/weather.html" element={<WeatherMain />} />
                    <Route path="/plan.html" element={<PlanMain />} />
                    <Route path="/weatherinfo.html" element={<WeatherInfo />} />
                    <Route path="/we" element={<We />} />
                    <Route path="/today.html" element={<TodayWeather />} />
                    <Route path="/ys.html" element={<YS />} />
                </Routes>
            </BrowserRouter>
        </>
    );
}

export default App;
